import type { FraisDTO } from '@/features/api/extranet/dto/Demande/shared'
import type { ErreurWithDirty } from '@/features/application/dirty'
import type { Status } from '@/features/domaine/property-status'
import type { ModelState } from '@/features/domaine/types/techniques'
import type { ModeFrais, NatureFrais } from '@/features/domaine/types/opco'
import type { LovDTO } from '@/features/api/extranet/dto/Lov'

export type MetaFrais = ModelState<FraisDTO, ErreurWithDirty<FraisDTO, number> & Status<FraisDTO>>

export type FraisDataParMode = Partial<Record<ModeFrais, FraisData>>

export type FraisData = {
  frais: FraisDTO[]
  metaFrais?: MetaFrais[]
  fraisTitre: string
  fraisField: string
  fraisHelp: { [key in NatureFrais]?: string } | null
  fraisTitreHelp?: string
}

type LigneFraisFrais = {
  type: 'frais'
  mode: ModeFrais
  fraisTitre: string
  fraisTitreHelp?: string
  frais: FraisDTO
  meta: MetaFrais
  isFirstOfMode: boolean
  hint?: string
}

type LigneFraisTotal = {
  type: 'total'
  mode: ModeFrais
  totalLabel: string
}

export type LigneFrais = LigneFraisFrais | LigneFraisTotal

export type FraisProps = {
  fraisDataParMode: FraisDataParMode
  readonly: boolean
  natureFrais: LovDTO<string>
  msgInformation?: string | null
  msgErreur?: string | null
  modifieFrais: ({
    mode,
    nature,
    valeur,
    field,
  }: {
    mode: ModeFrais
    nature: NatureFrais
    valeur: string | number | null | undefined
    field: keyof FraisDTO
  }) => void
}

export const LibelleTypeQuantiteFrais: { [key in NatureFrais]?: string } = {
  Hebergement: 'Nombre de nuitées',
  Repas: 'Nombre de repas',
} as const

export const LibelleTypeMontantFrais: { [key in NatureFrais]?: string } = {
  Hebergement: 'Coût par nuitée',
  Repas: 'Coût par repas',
} as const
